import {testIdProps} from '@github-ui/test-id-props'

import {AddColumnId} from '../../../hooks/tanstack-table/helpers/column-ids'
import {getHeaderCellPropsFromColumn} from '../../../hooks/tanstack-table/helpers/get-cell-styles'
import {getCanReorder, getColSpan} from '../../../hooks/tanstack-table/helpers/header-api'
import type {Header} from '../../../hooks/tanstack-table/helpers/types'
import {useGetDraggableHeaderProps} from '../../../hooks/tanstack-table/providers/columns/column-order-dnd-provider'
import {AddColumnHeader} from '../add-column-header'
import type {TableDataType} from '../table-data-type'
import {columnHeaderTestId} from '../test-identifiers'
import styles from './dummy-table-header-cell.module.css'
import {HeaderGridCell} from './header-grid-cell'
import {HeaderGridCellLayout} from './header-grid-cell-layout'

export const DummyHeaderCell = (props: {header: Header<TableDataType>; height: number}) => {
  const dragProps = useGetDraggableHeaderProps(props.header.id, getCanReorder(props.header))

  const headerProps = getHeaderCellPropsFromColumn({
    columnId: props.header.id,
    colSpan: getColSpan(props.header),
  })

  if (props.header.id === AddColumnId) {
    // workaround to ensure add column is rendered like our other header cells
    return (
      <HeaderGridCell
        tabIndex={-1}
        {...headerProps}
        {...dragProps.listeners}
        {...testIdProps(columnHeaderTestId(props.header.id))}
        ref={dragProps.setNodeRef}
      >
        <HeaderGridCellLayout className={styles.HeaderGridCellLayout}>
          <AddColumnHeader />
        </HeaderGridCellLayout>
      </HeaderGridCell>
    )
  }

  // eslint-disable-next-line react-hooks/refs
  return <div {...headerProps} role="cell" {...dragProps.listeners} ref={dragProps.setNodeRef} />
}

try{ DummyHeaderCell.displayName ||= 'DummyHeaderCell' } catch {}